module.exports = __webpack_public_path__ + "static/media/calendar-cube.7c90be13.png";